import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from '@mui/lab';
import { Typography, Box, Paper } from '@mui/material';
import { getTimeShort, getDayMonth, formatDateTime } from '../utils';
import getStepIcon from './StepIcon';
import StepActions from './StepActions';
import StepContent from './StepContent';
import { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';

function TripTimeline({ steps, onEditStep, onDeleteStep, onAddNote, getConnectedNotes }) {
  // Group steps by day
  const stepsByDay = {};
  steps.forEach((step) => {
    const date = getDayMonth(new Date(step.startDate));
    if (!stepsByDay[date]) {
      stepsByDay[date] = [];
    }
    stepsByDay[date].push(step);
  });

  return (
    <Box sx={{ maxWidth: '100%', ml: 0 }}>
      {Object.entries(stepsByDay).map(([day, daySteps], dayIndex) => (
        <Box key={day} sx={{ mb: 2 }}>
          <Paper
            elevation={0}
            sx={{
              bgcolor: '#d8e5bf',
              p: 1,
              borderRadius: 1,
              mb: 1,
              width: '100%'
            }}
          >
            <Typography variant="h6">{Object.keys(stepsByDay).length > 1 ? `Day ${dayIndex + 1} - ${day}` : day}</Typography>
          </Paper>

          <Timeline
            sx={{
              [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 0.2
              }
            }}
          >
            {daySteps.map((step, index) => (
              <TimelineItem key={step.id}>
                <TimelineSeparator>
                  <TimelineDot>{getStepIcon(step.type)}</TimelineDot>
                  {index < daySteps.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent>
                  <Box sx={{ mb: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ minWidth: 90 }}>
                        {getTimeShort(step.startDate)}
                        {step.endDate && (
                          <Typography variant="caption" display="block">
                            Ends {formatDateTime(step.endDate)}
                          </Typography>
                        )}
                      </Typography>
                      <Typography variant="h6" sx={{ fontSize: '1rem' }}>
                        {step.name}
                      </Typography>
                      <StepActions
                        onEdit={() => onEditStep(step, index)}
                        onDelete={() => onDeleteStep(index)}
                        onAddNote={() => onAddNote(step)}
                      />
                    </Box>
                    <StepContent step={step} getConnectedNotes={getConnectedNotes} />
                  </Box>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        </Box>
      ))}
    </Box>
  );
}

export default TripTimeline;
